/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityStcModel
 */
export interface EligibilityStcModel {
    /**
     * Code identifying the service type (e.g. '30' for Health Benefit Plan Coverage)
     */
    eligibility_stc_code?: string;
    /**
     * Human readable name of the service type
     */
    eligibility_stc_name?: string;
}

/**
 * Check if a given object implements the EligibilityStcModel interface.
 */
export function instanceOfEligibilityStcModel(value: object): value is EligibilityStcModel {
    return true;
}

export function EligibilityStcModelFromJSON(json: any): EligibilityStcModel {
    return EligibilityStcModelFromJSONTyped(json, false);
}

export function EligibilityStcModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityStcModel {
    if (json == null) {
        return json;
    }
    return {
        
        'eligibility_stc_code': json['eligibility_stc_code'] == null ? undefined : json['eligibility_stc_code'],
        'eligibility_stc_name': json['eligibility_stc_name'] == null ? undefined : json['eligibility_stc_name'],
    };
}

export function EligibilityStcModelToJSON(json: any): EligibilityStcModel {
    return EligibilityStcModelToJSONTyped(json, false);
}

export function EligibilityStcModelToJSONTyped(value?: EligibilityStcModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eligibility_stc_code': value['eligibility_stc_code'],
        'eligibility_stc_name': value['eligibility_stc_name'],
    };
}

